import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_Tag } from '@app/hcs-shared';
import { filterInstances } from '@nu-art/ts-common';
import { ConfigKeyFE_CriticalCareDiseaseTagId, ConfigKeyFE_CriticalCareMedicationsTagId, ConfigKeyFE_DiseasesViewsTagId, ConfigKeyFE_PossibleCriticalCareTagId } from './config-keys.js';
export const dispatch_onTagsUpdated = new ThunderDispatcherV3('__onTagsUpdated');
export class ModuleFE_Tag_Class extends ModuleFE_BaseApi {
    __searchFilterMapper = (item) => [item.label];
    __searchGroups = (items, filter) => {
        const diseaseViews = ConfigKeyFE_DiseasesViewsTagId.get();
        const diseaseViewsGroup = { group: 'Disease View', results: [] };
        const tagsGroup = { group: this.dbDef.entityName, results: [] };
        items.map(i => {
            if (i.tagIds.includes(diseaseViews) && (filter === 'DISEASE PROFILES' || !filter)) {
                diseaseViewsGroup.results.push({ _id: i._id, uiLabel: i.label });
            }
            else if (!filter || filter !== 'DISEASE PROFILES') {
                tagsGroup.results.push({ _id: i._id, uiLabel: i.label });
            }
        });
        return [diseaseViewsGroup, tagsGroup];
    };
    constructor() {
        super(DBDef_Tag, dispatch_onTagsUpdated);
    }
    getOnlyChildrenIdsByTagIds = (tagIds) => {
        if (!tagIds)
            return [];
        const tags = ModuleFE_Tag.cache.byIds(tagIds);
        // father's tag has empty tagIds
        return tags.filter(tag => tag.tagIds.length);
    };
    getTagsLabelByTagGroups = (tagGroups) => {
        const criticalTagIds = [
            ConfigKeyFE_CriticalCareDiseaseTagId.get(),
            ConfigKeyFE_PossibleCriticalCareTagId.get(),
            ConfigKeyFE_CriticalCareMedicationsTagId.get()
        ];
        return filterInstances(tagGroups
            .map(tagGroup => filterInstances(tagGroup.value
            .map(tagId => ({
            label: ModuleFE_Tag.cache.unique(tagId)?.label ?? 'Unknown tags',
            className: criticalTagIds.includes(tagId) ? 'critical-tag' : undefined
        }))))).flat();
    };
}
export const ModuleFE_Tag = new ModuleFE_Tag_Class();
//# sourceMappingURL=ModuleFE_Tag.js.map